import { z } from 'zod/v3';
import { makeFieldSchemaFromZod } from '../utils';

export const HorizontalInputGroupArrayCardUiOptionsSchema = z.object({
  addButtonLabel: z.string().optional(),
});

export type HorizontalInputGroupArrayCardUiOptions = z.infer<
  typeof HorizontalInputGroupArrayCardUiOptionsSchema
>;

export const HorizontalInputGroupArrayCardFieldSchema = makeFieldSchemaFromZod(
  z.array(z.object({})).describe('Horizontal Array Input Group Card'),
  HorizontalInputGroupArrayCardUiOptionsSchema,
);

export type HorizontalInputGroupArrayCardFieldProps =
  typeof HorizontalInputGroupArrayCardFieldSchema.type;

export const HorizontalInputGroupArrayCardSchema =
  HorizontalInputGroupArrayCardFieldSchema.schema;
